import { render, staticRenderFns } from "./CarouselCrossFade.vue?vue&type=template&id=2def7cbf&"
import script from "./CarouselCrossFade.vue?vue&type=script&lang=js&"
export * from "./CarouselCrossFade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports